import { AnimatePresence, motion, useReducedMotion } from "motion/react";

import { BALANCE_EASE } from "./AnimatedNumber";
import type { BalanceDecrease } from "../hooks/useBalanceDecrease";

import { cn } from "@/lib/utils/cn";

type DeductionPulseProps = {
  decrease: BalanceDecrease | null;
  format: (value: number) => string;
  className?: string;
};

export function DeductionPulse({ decrease, format, className }: DeductionPulseProps) {
  const reduceMotion = useReducedMotion();
  if (reduceMotion) return null;

  return (
    <AnimatePresence>
      {decrease && (
        <motion.span key={decrease.id} aria-hidden className="pointer-events-none absolute inset-0" data-testid="deduction-pulse">
          <motion.span
            className={cn("absolute inset-0 ring-2 ring-primary ring-inset", className)}
            initial={{ opacity: 0.55 }}
            animate={{ opacity: 0 }}
            transition={{ duration: 1.2, ease: BALANCE_EASE }}
          />
          <motion.span
            className="absolute right-3 top-1 text-xs font-semibold text-primary tabular-nums"
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: [0, 1, 1, 0], y: -10 }}
            transition={{ duration: 1.6, ease: BALANCE_EASE, times: [0, 0.15, 0.6, 1] }}
          >
            −{format(decrease.amount)}
          </motion.span>
        </motion.span>
      )}
    </AnimatePresence>
  );
}
